import { Observer } from 'rxjs';
import { DataSource } from '@angular/cdk/collections';
import { UntypedFormControl } from '@angular/forms';
import { StorageService } from './../../../../services/storage.service';
import { Component, OnInit } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';
import { sections } from '../sections.model';
import { SectionsService } from '../../sections.service';

export class SectionsDataSource extends DataSource<sections> {
  observer: Observer<sections[]>;

  refreshData(data: sections[]) {
    if (this.observer) {
      this.observer.next(data);
    }
  }

  connect(): Observable<sections[]> {
    return new Observable((observer: Observer<sections[]>) => {
      this.observer = observer;
    });
  }

  disconnect() {
    this.observer = null;
  }
}

@Component({
  selector: 'app-sections-list',
  templateUrl: './sections-list.component.html',
  
  styleUrls: ['./sections-list.component.scss']
})
export class SectionsListComponent implements OnInit {
  loading = false;
  pageSize = 100;
  dataSource = new SectionsDataSource();
  appIdFilter$: BehaviorSubject<string | null> = new BehaviorSubject(null);
  nameCategory = new UntypedFormControl('');
  currentAppId: string;
  allowedAppIds: string[];
  allowAllAppIds = false;
  requiredFields: boolean = true;
  data: sections[];
  resultsFound = true;
  displayedColumns = ['id'];
  hoveredRow: any;
  dataSearch:sections[];
  dataFilter:sections[];
  constructor(
    private router: Router,
    private storageService: StorageService,
    private sectionsService: SectionsService,
    private authService: AuthService,
  ) {
    
  }

  async ngOnInit() {
    await this.initAllowedIds();
    this.getSection();
  }

  initAllowedIds() {
    // Do not allow any app by default
    this.allowedAppIds = [];
    this.allowAllAppIds = false;
    const account = this.storageService.get('account');
    if (!account) {
      return;
    }
    if (account.roles.includes('super_admin')) {
      // Allow all ids
      this.allowedAppIds = null;
      this.allowAllAppIds = true;
      return;
    }
    const profile = this.storageService.get('profile');
    if (!profile) {
      return;
    }
    this.allowedAppIds = profile.authorized_apps || [];
  

 
  }

  getSection(appId?,name?) {
    if(appId){
      this.requiredFields = true;
    } else {
      this.requiredFields = false;
      this.data = [];
      this.dataSource.refreshData(this.data);
      return;
    }
    this.loading = true;
    this.sectionsService.getSections(appId).subscribe((data)=>{

      this.data = data.data;
      this.data = appId ? this.data.filter(x => x.app_id == appId) : this.data;
      this.data = name ? this.data.filter(x => x.name == name) : this.data;
      
      // this.data = this.data.sort(function(a,b){
      //   return new Date(b.createdAt).valueOf() - new Date(a.createdAt).valueOf()})
      this.data

      this.dataSource.refreshData(this.data);
      this.loading= false
      this.resultsFound = this.data.length > 0 ? true : false;

      if(!name){
        this.dataSearch = this.data;
        this.dataFilter = this.data;
      }
    })
  }

  /* onUserSelected(user: AppUserOutput) {} */

  onAppSelected(appId: string) {
    this.appIdFilter$.next(appId);
    this.currentAppId = appId;
    this.getSection(this.currentAppId)
  }

 

  resetApp() {
    this.currentAppId = null;
  }

  onEdit(item:sections) {
    this.router.navigate(['pages', 'sections', 'edit',item.id]);
  }
  onCreate(){
    this.router.navigate(['pages', 'sections', 'add']);
  }

  getRowBackgroundColor(row) {
     return row === this.hoveredRow ? '#F5F5F5' : 'transparent'; 
  }


  clearData(value){
    const val = String(value.target.value).toLowerCase();
    if(!val){
      this.getSection(this.currentAppId);
    } else {
      this.dataFilter = this.dataSearch.filter(x => String(x.name).toLowerCase().includes(val))
    }
  }

  onIdOptionSelected(option){
    const name = option.option.value;
    this.dataFilter = name ? this.data.filter(x => x.name == name) : this.data;
    this.dataSource.refreshData(this.dataFilter);
  }

  goToIcon(url){
    window.open(url, '_blank');
    return false;
  }

}

